import { StepManagerState } from '@/store/step-manager/state';
import { StepManagerGetters } from '@/store/step-manager/getters';
import { StepManagerMutations } from '@/store/step-manager/mutations';
import { Actions } from 'vuex-smart-module';
import Axios, { AxiosError } from 'axios';
import { DealProgressService } from '@/services/deal-progress-service';
import { ServiceContainer } from '@/services/container';
import { DealStatus, UpdateDealStateRequest } from '@/types/deal-progress';
import { captureException, setTag } from '@sentry/browser';

interface DealProgressActionsDependencies {
	services: ServiceContainer;
}

export class StepManagerActions extends Actions<
	StepManagerState,
	StepManagerGetters,
	StepManagerMutations,
	StepManagerActions
	> {
	self = this;

	dealProgressService!: DealProgressService

	$setDependencies(dependencies: DealProgressActionsDependencies): void {
		this.self.dealProgressService = dependencies.services.dealProgress;
	}

	async processError(payload?: AxiosError): Promise<void> {
		if (Axios.isCancel(payload)) {
			return Promise.resolve();
		}
		this.mutations.unsetLoading();
		console.error(payload);
		setTag('info', 'stepManagerProcessError');
		captureException(payload);

		return Promise.resolve();
	}

	async getDealProgressStatus(writeupId: number): Promise<void|DealStatus> {
		this.mutations.setLoading();
		const response = await this.dealProgressService.getStepsStates(writeupId)
			.catch(error => this.actions.processError(error));

		if (response) {
			this.mutations.unsetLoading();
			this.mutations.updateDealProgressStatus(response);
		}
		return Promise.resolve();
	}

	async updateDealProgress(data: UpdateDealStateRequest): Promise<void|DealStatus> {
		this.mutations.setLoading();
		const response = await this.dealProgressService.updateStepStatus(data.writeupId, data)
			.catch(error => this.actions.processError(error));

		if (response) {
			this.mutations.unsetLoading();
			this.mutations.updateDealProgressStatus(response);
		}
		return Promise.resolve();
	}
}
